export default "__VITE_ASSET__87b9f18a__"